import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import DatePicker from "components/v2/DatePicker/DatePicker";
import { useGetShipmentDetails } from "api/queries/shipments/useGetShipmentDetails";
import { DateTimeFormat, formatDate, getTimezoneOffset } from "helpers/dateTimeHelper";
import TimeInput from "components/v2/TimeInput/TimeInput";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import ProofOfPickupDeliveryTimezone from "./ProofOfPickupDeliveryTimezone";

const ProofOfPickup = function () {
  const { id } = useParams();

  const { data: shipmentData }: any = useGetShipmentBasic(id!, {
    enabled: !!id,
    refetchOnMount: false,
  });

  const { data: shipmentDetails = {} } = useGetShipmentDetails(id!, true, {
    enabled: !!id,
    refetchOnMount: false,
  });
  const isPoPSubmitted = shipmentDetails?.schedule?.is_proof_of_pickup_submitted;
  const popDate = shipmentDetails?.schedule?.proof_of_pickup_date;
  const popTime = shipmentDetails?.schedule?.proof_of_pickup_time;
  const isOffPlatform = shipmentData?.shipment?.is_off_platform_shipment || false;

  return (
    <>
      <Row>
        <Col md="6">
          {!isOffPlatform || isPoPSubmitted ? (
            <>
              <div className="text-sm text-secondary-v2 font-medium mb-xs">
                <FormattedMessage id="components.molecules.top-nav.pickupLocation" defaultMessage="Pickup location" />
              </div>
              <div className="text-md text-primary">
                {shipmentDetails?.schedule?.pickup_city || shipmentDetails?.schedule?.pickup_country} (
                {getTimezoneOffset(shipmentDetails?.schedule?.pickup_timezone)})
              </div>
            </>
          ) : (
            <ProofOfPickupDeliveryTimezone country={shipmentDetails?.schedule?.pickup_country} name="pickup_timezone" />
          )}
        </Col>

        {isPoPSubmitted && (
          <Col md="6">
            <div className="text-sm text-secondary-v2 font-medium mb-xs">
              <FormattedMessage id="components.molecules.top-nav.pickupDate" defaultMessage="Pickup date" />
            </div>
            <div className="text-md text-primary">
              {formatDate(`${popDate} ${popTime}`, DateTimeFormat.fullDateTimeFormat)}
            </div>
          </Col>
        )}
      </Row>
      {!isPoPSubmitted && (
        <Row className="mt-3xl">
          <Col md="6">
            <div className="text-sm text-secondary-v2 font-medium mb-sm">
              <FormattedMessage id="components.molecules.top-nav.pickupDate" defaultMessage="Pickup date" />
              <span className="text-danger ml-xss">*</span>
            </div>
            <DatePicker
              name="pickup_date"
              selectionMode="single"
              alignment="right"
              numberOfMonths={1}
              maxDate={moment().toDate()}
              required
            />
          </Col>
          <Col md="6">
            <div className="text-sm text-secondary-v2 font-medium mb-sm">
              <FormattedMessage id="components.molecules.top-nav.pickupTime" defaultMessage="Pickup time" />
              <span className="text-danger ml-xss">*</span>
            </div>
            <TimeInput name="pickup_time" required />
          </Col>
        </Row>
      )}
    </>
  );
};

export default ProofOfPickup;
